import { Validators } from '@angular/forms';
import { Formulario } from '../../interface/fomulario';

export class AutorizacionImagenes implements Formulario {
    createFormulario(): any[] {
        const form = [{element: 'text', name: 'firstname', label: 'Nombre*', validations: [Validators.required]},
        {element: 'text', name: 'lastname', label: 'Apellidos*', validations: [Validators.required]}
    ];
        return form;
    }
}
